<template>

      <v-card
        class="mx-auto"
        max-width="1000"
        min-width="300"
      >
        <v-toolbar class="pencil"  :color="ToolColor" dark @click="Loadin();Hide = !Hide">
          <v-toolbar-title>{{ Headline }}</v-toolbar-title>

          <v-toolbar-side-icon color="white darken-1">
            <v-icon v-if="Hide == false" color="orange ligthen-1" >arrow_downward</v-icon>
            <v-icon v-else color="orange ligthen-1">arrow_upward</v-icon>
          </v-toolbar-side-icon>

          <v-spacer></v-spacer>
        </v-toolbar>
        
  <v-expand-transition >
        <div v-if="Hide">
          
  <SendtoNurse :schoolId="schoolId" As="teacher"  :reporter="teacher.name"    v-model="send" />
     <div  v-if="f.length!=0">
    <v-flex justify="center">
      <v-dialog v-model="dialogAccess" persistent max-width="600px">



    <v-toolbar
      color="amber lighten-2"
      dark
    >
      <v-toolbar-title class="headline"> Uppdatera åtgärdsplanen för {{accessItem.name }} 
            <v-icon dark @click="showTipSnackbar('Här ska du uppdatera åtgärdsplanen så elevhälsopersonalen kan ge dig den bästa återkopplingen.')"> info </v-icon></v-toolbar-title>
    </v-toolbar>
    <v-list>
          <h3 class="title font-weight-light mb-2 ml-2">Åtgärdsplan:</h3>
              <v-textarea
          solo
          v-model="accessItem.plan"
          name="input-7-4"
          label="Åtgärdsplan"
        ></v-textarea> 
         <h3 class="title font-weight-light mb-2 ml-2">Status:</h3>  

<v-tooltip  bottom v-for="smile in smileys" :key="smile.text">
            

      <template v-slot:activator="{ on, attrs }">

<v-btn
              large
              class="button text-blanco text-shadow-negra"
             
                       v-bind="attrs"  v-on="on"
            @click="accessItem.status=smile.smile"
              fab
            >
         
          {{smile.smile }}
          </v-btn>
          
           </template>      <span>{{smile.text}}</span>    </v-tooltip>

                       <v-spacer></v-spacer>
            <v-btn dark color="blue darken-1" @click="update_Plan()">
              Stäng
            </v-btn>
        </v-list>

     
      </v-dialog>
<RemoveWindow 
        v-model="dialogDelete" Type="Nurse"  :removeItem="removeItem"  Headline="Ta bort F(varning) för" WarningText="Har eleven klarat sig förbi sina hinder? Hurra för både eleven och dig, bra jobbat!"    />
       </v-flex>

              <v-btn @click="send=true" dark color="green ligthen-1">
 Lägg till F eller F-varning
  </v-btn>

                   <v-text-field
          v-model="search"
          label="Sök efter elev"
          class="mx-4"
        ></v-text-field>

         <v-toolbar  color="amber lighten-3" dark @click="HideFV = !HideFV">
          <v-toolbar-title>F-varning</v-toolbar-title>

          <v-toolbar-side-icon color="white darken-1">
            <v-icon v-if="HideFV == false" color="orange ligthen-1" >arrow_downward</v-icon>
            <v-icon v-else color="orange ligthen-1">arrow_upward</v-icon>
          </v-toolbar-side-icon>

          <v-spacer></v-spacer>
        </v-toolbar>
      <v-data-table v-if="HideFV"
      :headers="headers"
      :items="f.filter(item => item.activity=='f-varning') "
      item-key="name"
      sort-by="name"
      class="elevation-1"      
      :pagination.sync="pagination"
      :search="search"
      show-group-by
    >
      <template v-slot:items="props">
        <td class="text-xs-right">{{ props.item.name }}</td>
        
        <td class="text-xs-right">{{ props.item.class }}</td>
      
        <td class="text-xs-right">          
          {{
              props.item.course
          }}
        </td>

                        <td class="text-xs-right">          
          {{
              props.item.cause
          }}
        </td>
        <td class="text-xs-right">          
          {{
              props.item.plan
          }}
        </td>
         <!-- <td class="text-xs-right"  v-if="role=='eht'">
                  {{  props.item.hasOwnProperty('createDate') ?    locfun.getDate(
              props.item.createDate
            ): 'Ingen data att visa' }} 
        </td> -->
     <td class="text-xs-right">
                  {{  props.item.hasOwnProperty('feedback') ?   
              props.item.feedback
            : 'Ingen återkoppling att visa' }} 
        </td>
     <td class="text-xs-right">
                  {{  props.item.hasOwnProperty('status') ?   
     
              props.item.status
            : 'Ingen status att visa' }} 
        </td>
         <td class="text-xs-right">
                 {{  props.item.hasOwnProperty('changeDate') ?  
              props.item.changeDate
            : 'Ingen data att visa' }} 
        </td>

        <td  class="text-xs-right">
          <v-btn
            class="mx-2"
            fab
            dark
            small
            @click="
              accessItem=props.item;accessItem.Oldplan=accessItem.plan; dialogAccess = true;
            "
            color="green ligthen-1"
          >
            <v-icon dark> upgrade </v-icon>
          </v-btn>
        </td>
        <td class="text-xs-right" >
  <v-btn
            class="mx-2"
            fab
            dark
            small
            @click="
              removeItem = props.item;
              dialogDelete = true;
            "
            color="red ligthen-1"
          >
            <v-icon dark> clear </v-icon>
          </v-btn>
        </td>

      </template>
            <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
         Det finns inget resultat för din sökning på "{{ search }}". 
        </v-alert>
      </template>
    </v-data-table>

    
     <v-toolbar  color="amber lighten-4" dark @click="HideF = !HideF">
          <v-toolbar-title>F</v-toolbar-title>

          <v-toolbar-side-icon color="white darken-1">
            <v-icon v-if="HideF == false" color="orange ligthen-1" >arrow_downward</v-icon>
            <v-icon v-else color="orange ligthen-1">arrow_upward</v-icon>
          </v-toolbar-side-icon>

          <v-spacer></v-spacer>
        </v-toolbar>


    <v-data-table  v-if="HideF"
      :headers="headers"
      :items="f.filter(item => item.activity=='f') "
      item-key="name"
      sort-by="name"
      class="elevation-1"      
      :pagination.sync="pagination"
      :search="search"
      show-group-by
    >
      <template v-slot:items="props">
        <td class="text-xs-right">{{ props.item.name }}</td>
        
        <td class="text-xs-right">{{ props.item.class }}</td>
      
        <td class="text-xs-right">          
          {{
              props.item.course
          }}
        </td>
                <td class="text-xs-right">          
          {{
              props.item.cause
          }}
        </td>
        <td class="text-xs-right">          
          {{
              props.item.plan
          }}
        </td>
         <!-- <td class="text-xs-right"  v-if="role=='eht'">
                  {{  props.item.hasOwnProperty('createDate') ?    locfun.getDate(
              props.item.createDate
            ): 'Ingen data att visa' }} 
        </td> -->
     <td class="text-xs-right">
                  {{  props.item.hasOwnProperty('feedback') ?   
              props.item.feedback
            : 'Ingen återkoppling att visa' }} 
        </td>

         <td class="text-xs-right">
                 {{  props.item.hasOwnProperty('changeDate') ?  
              props.item.changeDate
            : 'Ingen data att visa' }} 
        </td>

        <td  class="text-xs-right">
          <v-btn
            class="mx-2"
            fab
            dark
            small
            @click="
              accessItem=props.item;accessItem.Oldplan=accessItem.plan; dialogAccess = true;
            "
            color="green ligthen-1"
          >
            <v-icon dark> upgrade </v-icon>
          </v-btn>
        </td>
        <td class="text-xs-right" >
  <v-btn
            class="mx-2"
            fab
            dark
            small
            @click="
              removeItem = props.item;
              dialogDelete = true;
            "
            color="red ligthen-1"
          >
            <v-icon dark> clear </v-icon>
          </v-btn>
        </td>

      </template>
            <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
         Det finns inget resultat för din sökning på "{{ search }}". 
        </v-alert>
      </template>
    </v-data-table>
             <div class="text-xs-center pt-2">
      <v-btn color="light-blue darken-1" dark @click="toggleOrder">Ändra sorteringsordning</v-btn>
      <v-btn color="light-blue darken-1" dark @click="nextSort">Sortera på nästa kolumn</v-btn>
    </div>
  </div>
     <div v-else  class="bellowPen" :class="ToolColor+ ' lighten-2 text-center'">  
    <span class="tt" color="white">Det finns inga F eller F-varningar.</span>
      <v-btn @click="send=true" dark color="green ligthen-1">
    Lägg till F eller F-varning
  </v-btn>
    </div>
        </div>
  </v-expand-transition>
      </v-card>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import fun from "../functions";
// import NewAP from "./NewAP";
import RemoveWindow from "../assets/RemoveWindow";
import SendtoNurse from '../SendtoNurse.vue';
export default {
  name: "Course",
  components: {
    RemoveWindow,
    SendtoNurse
  },
  props: {
    // content: Array,
    Headline: String,
    ToolColor: String,
    schoolId: String,
    teacher: Object,
    // role: String,
    id: String,
    
  },

  watch: {
  },
  created() {
    this.locfun = new fun();
//   }
  },
  computed: {
    ...mapGetters("teachers", ["teachernameandId","f","FFetched"]),
    ...mapGetters("ehtmembers", ["membernameandId",]),
    ...mapGetters("classesAP", ["classesnameandId",'classes']),
  },
  methods: {
    Loadin()
    {
    if (this.FFetched==false) {
      //console.log("Fetched")
     this.initF(this.teacher)
}  
    },
update_Plan(){

  if (this.accessItem.plan !=this.accessItem.Oldplan) {
    delete this.accessItem.Oldplan;
    this.accessItem.Type="update";
this.updatePlan(this.accessItem);
this.showSuccessSnackbar("Åtgärdsplanen är uppdaterad.")
  }
this.dialogAccess = false;

},

    ...mapActions("ehtmembers", ["updatePlan"]),
    ...mapActions(['showTipSnackbar','showSuccessSnackbar']),
    toggleOrder () {
        this.pagination.descending = !this.pagination.descending
      },
      nextSort () {
        let index = this.headers.findIndex(h => h.value === this.pagination.sortBy)
        index = (index + 1) % this.headers.length
        index = index === 0 ? index + 1 : index
        this.pagination.sortBy = this.headers[index].value
      },




    ...mapActions('teachers', ['initF']),
    ...mapActions(["showSuccessSnackbar"]),
  },
  data() {
    return {
      send:false,
      search: '',
            pagination: {
          sortBy: 'steps[0].starttime'
        },
        smileys:
       [ { smile:"😳", text:"önskar stöttning"}, {smile: "😌", text:"arbetet går framåt"}, { smile:"🤓" , text:"eleven är nära måluppfyllelse "}, { smile:"🥳", text:" eleven har kompletterat"}, { smile:'🤩' ,text:"eleven har uppnått målbilden"}],
 
      removeItem: { name: "temp", id: "temp" },
      accessItem: { name: "temp", id: "temp" },
      dialogDelete: false,
      dialogAccess: false,
      dis: {},
      dialog: false,
      dialogClass: false,
      Class: null,
      Choosen: null,
      Hide: false,
      HideF: true,
      HideFV: true,
      headers: [
        {
          text: "Elevnamn",
          align: "start",
          value: "name"
        },
        { text: "Klass", value: "class", align: "right" },
        { text: "Kurs", value: "course", align: "right" , access:"eht"},
        { text: "Härledande orsak", value: "cause", align: "right" },
        { text: "Åtgärdsplan", value: "plan", align: "right" },
        { text: "Återkoppling", value: "feedback", align: "right" },
        { text: "Status", value: "status", align: "right" },
        { text: "Startdatum", value: "changeDate", align: "right" },
        // { text: "Uppladdat", value: "uploadDate", align: "right", access:"eht" },
        // { text: "Utgår", value: "expireDate", align: "right" },
        { text: "Ändra", value: "ändra", align: "right" , access:"eht" },
        { text: "Ta bort", value: "tabort", align: "right" , access:"eht"},
      ],
    };
  },
};
</script>

<style >
.button {
  font-size: 30px;
}

</style>